<template>
    <main-layout>

    </main-layout>
</template>

<script>

import Detenteur from "@/js/models/Detenteur";
import Installation from "@/js/models/Installation";
import Fluide from "@/js/models/Fluide";
import localforage from "localforage";

export default {
    data(){
        return {
            detenteur: null,
        }
    },

    methods:{
        abandon() {
            swal.close();
            this.$router.push({ name: 'home' });
        },

        async updateSwalMessage(message) {
            // Fermer la popup actuelle et en ouvrir une nouvelle avec le nouveau message
            swal.close();
            swal({
                title: 'Traitement en cours...',
                text: message,
                type: 'info',
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                showCancelButton: false,
                onOpen: () => {
                    swal.showLoading();
                }
            });
        },

        async initialize(data) {
            // Afficher la popup de chargement initiale
            swal({
                title: 'Traitement en cours...',
                text: 'Recherche du détenteur...',
                type: 'info',
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                showCancelButton: false,
                onOpen: () => {
                    swal.showLoading();
                }
            });

            let Det = null;
            let detenteurCreated = false;
            let installationCreated = false;

            try {
                if (data.detenteur.id_fi360 !== null) {
                    await this.updateSwalMessage('Récupération du détenteur...');

                    try {
                        Det = await Detenteur.getDetenteur(data.detenteur.id_fi360);
                    } catch (error) {
                        swal.close();
                        swal("Erreur", "L'identifiant que vous avez fourni n'est pas valide dans F.i360°", "error");
                        return;
                    }
                } else {
                    await this.updateSwalMessage('Recherche du détenteur...');

                    // Nettoyer le SIRET si présent
                    let siret = data.detenteur.siret || '';
                    if (siret && siret !== null) {
                        siret = siret.replace(/\s/g, '');
                    }

                    // Recherche d'abord par SIRET si disponible (identifiant unique)
                    if (siret && /^\d{14}$/.test(siret)) {
                        try {
                            const list = await Detenteur.getList();
                            Det = list.find(d => d.siret === siret);
                            if (Det) {
                                await this.updateSwalMessage('Détenteur trouvé par SIRET');
                            }
                        } catch (error) {
                            // Ignorer l'erreur, on continuera avec la recherche normale
                        }
                    }

                    // Si pas trouvé par SIRET, recherche par nom/code postal/ville
                    if (!Det) {
                        try {
                            Det = await Detenteur.searchByDetenteur({
                                "raison_sociale" : data.detenteur.name,
                                "code_postal" : data.detenteur.zipcode,
                                "ville" : data.detenteur.city,
                            });
                            if (Det) {
                                await this.updateSwalMessage('Détenteur trouvé');
                            }
                        } catch (error) {
                            // Recherche élargie d'homonymes avant de créer
                            await this.updateSwalMessage('Recherche de clients similaires...');

                            const allDetenteurs = await Detenteur.getList();
                            const searchName = (data.detenteur.name || '').toLowerCase().trim();
                            const searchZipcode = (data.detenteur.zipcode || '').trim();
                            const searchCity = (data.detenteur.city || '').toLowerCase().trim();
                            const searchPhone = (data.detenteur.phone || '').replace(/\s/g, '');

                            // Recherche large : nom similaire OU même téléphone
                            const homonymes = allDetenteurs.filter(d => {
                                const dName = (d.raison_sociale || '').toLowerCase().trim();
                                const dZipcode = (d.code_postal || '').trim();
                                const dCity = (d.ville || '').toLowerCase().trim();
                                const dPhone = (d.telephone || '').replace(/\s/g, '');
                                const dPortable = (d.portable || '').replace(/\s/g, '');

                                // Correspondance par nom (contient ou est contenu)
                                const nameMatch = searchName && dName &&
                                    (dName.includes(searchName) || searchName.includes(dName));

                                // Correspondance par téléphone
                                const phoneMatch = searchPhone && searchPhone.length >= 10 &&
                                    (dPhone === searchPhone || dPortable === searchPhone);

                                // Correspondance nom + code postal
                                const nameAndZipcodeMatch = nameMatch && searchZipcode && dZipcode === searchZipcode;

                                // Correspondance nom + ville
                                const nameAndCityMatch = nameMatch && searchCity && dCity === searchCity;

                                return nameAndZipcodeMatch || nameAndCityMatch || phoneMatch;
                            });

                            if (homonymes.length > 0) {
                                // Proposer la liste des homonymes à l'utilisateur
                                swal.close();

                                const inputOptions = {};
                                homonymes.forEach(d => {
                                    const label = (d.raison_sociale || 'Sans nom')
                                        + ' — ' + (d.code_postal || '?') + ' ' + (d.ville || '?');
                                    inputOptions[d.id] = label;
                                });

                                let result = null;
                                try {
                                    result = await swal({
                                        title: 'Clients similaires trouvés',
                                        text: 'Sélectionnez le client correspondant ou créez-en un nouveau',
                                        input: 'select',
                                        inputOptions: inputOptions,
                                        inputPlaceholder: 'Choisissez un client...',
                                        showCancelButton: true,
                                        cancelButtonText: 'Créer un nouveau client',
                                        confirmButtonText: 'Sélectionner',
                                        inputValidator: (value) => {
                                            return new Promise((resolve, reject) => {
                                                if (value) {
                                                    resolve();
                                                } else {
                                                    reject('Veuillez sélectionner un client');
                                                }
                                            });
                                        }
                                    });
                                } catch (dismiss) {
                                    if (dismiss !== 'cancel') {
                                        this.abandon();
                                        return;
                                    }
                                }

                                if (result) {
                                    // L'utilisateur a sélectionné un détenteur existant
                                    let selectedId = result;
                                    if (!String(selectedId).includes('N-')) {
                                        selectedId = parseInt(selectedId);
                                    }
                                    Det = allDetenteurs.find(d => d.id === selectedId);
                                    await this.updateSwalMessage('Détenteur sélectionné');
                                }
                            }

                            // Si toujours pas de Det (pas d'homonymes ou annulé), créer
                            if (!Det) {
                                await this.updateSwalMessage('Création du détenteur...');

                                // Déterminer le type en fonction du SIRET
                                let type = 'Particulier';

                                if (siret && /^\d{14}$/.test(siret)) {
                                    type = 'Société';
                                }

                                const newDetenteur = {
                                    type: type,
                                    raison_sociale: data.detenteur.name || '',
                                    code_client: '',
                                    siret: siret || '',
                                    ville: data.detenteur.city || '',
                                    code_postal: data.detenteur.zipcode || '',
                                    adresse: data.detenteur.address || '',
                                    complement_adresse: '',
                                    telephone: data.detenteur.phone || '',
                                    email: data.detenteur.email || '',
                                    nom: '',
                                    portable: '',
                                    direct: '',
                                    actif: true
                                };

                                await Detenteur.addDetenteurOffline(newDetenteur);
                                // Récupérer le détenteur créé pour le retourner
                                const list = await Detenteur.getList();
                                Det = list[list.length - 1];
                                detenteurCreated = true;
                                await this.updateSwalMessage('Détenteur créé avec succès');
                            }
                        }
                    }
                }

                // Gestion de l'installation
                if (!Det) {
                    swal.close();
                    swal('Erreur', 'Détenteur non trouvé, impossible de continuer', 'error');
                    return;
                }

                let Inst = null;

                if (data.installation && data.installation.id_fi360 != null) {
                    await this.updateSwalMessage('Récupération de l\'installation...');

                    try {
                        Inst = await Installation.getInstallation(data.installation.id_fi360);

                        // Vérifier qu'elle appartient bien au détenteur
                        let detenteurId = Det.id;
                        let installationDetenteurId = Inst.detenteur;

                        // Normaliser les IDs pour la comparaison
                        if (!_.includes(detenteurId, 'N-')) {
                            detenteurId = parseInt(detenteurId);
                        }
                        if (!_.includes(installationDetenteurId, 'N-')) {
                            installationDetenteurId = parseInt(installationDetenteurId);
                        }

                        if (detenteurId !== installationDetenteurId) {
                            // L'installation n'appartient pas au détenteur, on la crée
                            Inst = null;
                            await this.updateSwalMessage('Installation n\'appartient pas au détenteur, création...');
                        } else {
                            await this.updateSwalMessage('Installation trouvée');
                        }
                    } catch (error) {
                        // L'installation n'existe pas, on la crée
                        Inst = null;
                        await this.updateSwalMessage('Installation non trouvée, recherche d\'une installation similaire...');
                    }
                } else {
                    await this.updateSwalMessage('Recherche de l\'installation...');
                }

                // Si l'installation n'existe pas ou n'appartient pas au détenteur, vérifier si une installation similaire existe déjà
                if (!Inst && data.installation) {
                    try {
                        // Récupérer toutes les installations du détenteur
                        const installationsDet = await Installation.getInstallationsForDet(Det.id);

                        // Chercher un match exact (nom + marque/modèle)
                        const searchName = (data.installation.name || '').toLowerCase().trim();
                        const searchBrand = (data.installation.brand || '').toLowerCase().trim();
                        const searchModel = (data.installation.model || '').toLowerCase().trim();

                        const installationExacte = installationsDet.find(inst => {
                            const nomMatch = searchName && (inst.nom || '').toLowerCase().trim() === searchName;
                            const marqueMatch = searchBrand && (inst.marque || '').toLowerCase().trim() === searchBrand;
                            const modeleMatch = searchModel && (inst.modele || '').toLowerCase().trim() === searchModel;

                            // Match exact : nom + (marque ou modèle si fournis)
                            if (!nomMatch) return false;
                            if (searchBrand || searchModel) return marqueMatch || modeleMatch;
                            return true;
                        });

                        if (installationExacte) {
                            // Match exact, on l'utilise directement
                            Inst = installationExacte;
                            await this.updateSwalMessage('Installation trouvée');
                        } else if (installationsDet.length > 0) {
                            // Pas de match exact mais des installations existent : proposer la liste
                            swal.close();

                            const inputOptions = {};
                            installationsDet.forEach(inst => {
                                const parts = [inst.nom || 'Sans nom'];
                                if (inst.marque) parts.push(inst.marque);
                                if (inst.modele) parts.push(inst.modele);
                                inputOptions[inst.id] = parts.join(' — ');
                            });

                            let result = null;
                            try {
                                result = await swal({
                                    title: 'Installations existantes',
                                    text: 'Une installation similaire existe peut-être déjà. Sélectionnez-la ou créez-en une nouvelle.',
                                    input: 'select',
                                    inputOptions: inputOptions,
                                    inputPlaceholder: 'Choisissez une installation...',
                                    showCancelButton: true,
                                    cancelButtonText: 'Créer une nouvelle installation',
                                    confirmButtonText: 'Sélectionner',
                                    inputValidator: (value) => {
                                        return new Promise((resolve, reject) => {
                                            if (value) {
                                                resolve();
                                            } else {
                                                reject('Veuillez sélectionner une installation');
                                            }
                                        });
                                    }
                                });
                            } catch (dismiss) {
                                if (dismiss !== 'cancel') {
                                    this.abandon();
                                    return;
                                }
                            }

                            if (result) {
                                let selectedId = result;
                                if (!String(selectedId).includes('N-')) {
                                    selectedId = parseInt(selectedId);
                                }
                                Inst = installationsDet.find(inst => inst.id === selectedId);
                                await this.updateSwalMessage('Installation sélectionnée');
                            }
                        }

                        // Si toujours pas d'installation (aucune existante ou l'utilisateur veut créer), on crée
                        if (!Inst) {
                            await this.updateSwalMessage('Création de l\'installation...');

                            // Récupérer la liste des fluides pour trouver le fluide correspondant
                            const fluidesData = JSON.parse(await localforage.getItem('listFluides'));
                            const fluides = fluidesData.noFiltre || [];

                            // Chercher le fluide par son nom (ex: "R-32")
                            let fluideObj = null;
                            if (data.installation.fluid) {
                                fluideObj = fluides.find(f => {
                                    const nom = f.nom ? f.nom.toLowerCase().replace(/-/g, '') : '';
                                    const nomCommercial = f.nom_commercial ? f.nom_commercial.toLowerCase().replace(/-/g, '') : '';
                                    const fluidSearch = data.installation.fluid.toLowerCase().replace(/-/g, '');
                                    return nom === fluidSearch || nomCommercial === fluidSearch;
                                });
                            }

                            // Créer l'objet installation
                            const newInstallation = {
                                nom: data.installation.name || '',
                                marque: data.installation.brand || '',
                                modele: data.installation.model || '',
                                fluide: fluideObj || null,
                                charge: data.installation.load || null,
                                detecteur: false, // Par défaut, on met false
                                photo: null,
                                i_tag: null
                            };

                            // Calculer le tonnage et la fréquence si fluide et charge sont présents
                            if (fluideObj && newInstallation.charge) {
                                newInstallation.tonnage = Fluide.calcTonnage(fluideObj, newInstallation.charge);
                                newInstallation.frequence_controle = Installation.calcFrequence(
                                    newInstallation.detecteur,
                                    newInstallation.tonnage,
                                    newInstallation.charge,
                                    fluideObj
                                );
                            }

                            // Créer l'installation en local
                            await Installation.addInstallationOffline({
                                data: { installation: newInstallation },
                                idDet: Det.id
                            });

                            // Récupérer l'installation créée
                            const list = await Installation.getList();
                            Inst = list[list.length - 1];
                            installationCreated = true;
                            await this.updateSwalMessage('Installation créée avec succès');
                        }
                    } catch (createError) {
                        console.error('Erreur lors de la création de l\'installation:', createError);
                        swal.close();
                        swal('Erreur', 'Impossible de créer l\'installation', 'error');
                        return;
                    }
                }

                // Préparer le message de succès
                let successMessage = 'Traitement terminé avec succès !<br>';
                if (detenteurCreated) {
                    successMessage += '<br>✓ Détenteur créé';
                } else {
                    successMessage += '<br>✓ Détenteur trouvé';
                }
                if (installationCreated) {
                    successMessage += '<br>✓ Installation créée';
                } else if (Inst) {
                    successMessage += '<br>✓ Installation trouvée';
                }

                // Vérifier que tout est prêt pour la redirection
                if (!Det) {
                    swal.close();
                    swal('Erreur', 'Détenteur non trouvé ou non créé', 'error');
                    return;
                }

                if (!Inst) {
                    swal.close();
                    swal('Erreur', 'Installation non trouvée ou non créée. Impossible de continuer.', 'error');
                    return;
                }

                // Préparer les IDs pour la query (gérer les IDs temporaires "N-")
                const detenteurId = Det.id;
                const installationId = Inst.id;

                // Préparer les query params
                const queryParams = {
                    detenteur: detenteurId,
                    installation: installationId
                };
                
                // Encoder le callback en base64 s'il est présent dans les données
                if (data.callback) {
                    queryParams.callback = btoa(data.callback);
                }

                // Fermer la popup de chargement et attendre un peu pour s'assurer qu'elle est bien fermée
                swal.close();

                // Attendre un court délai pour s'assurer que la popup est bien fermée
                await new Promise(resolve => setTimeout(resolve, 100));

                // Afficher le message de succès avec redirection automatique après 2 secondes
                // Mais garder le bouton "Continuer" pour les utilisateurs impatients
                swal({
                    title: 'Succès !',
                    html: successMessage,
                    type: 'success',
                    confirmButtonText: 'Continuer',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    timer: 2000 // Redirection automatique après 2 secondes
                }).then(() => {
                    // Rediriger si l'utilisateur clique sur "Continuer" avant le timeout
                    this.$router.push({
                        name: 'new-fibsdd',
                        query: queryParams
                    });
                });

                // Redirection automatique après 2 secondes si l'utilisateur n'a pas cliqué
                setTimeout(() => {
                    // Vérifier si on est toujours sur la même page avant de rediriger
                    if (this.$route.name === 'connector-gazoleen') {
                        this.$router.push({
                            name: 'new-fibsdd',
                            query: queryParams
                        });
                    }
                }, 2000);

            } catch (error) {
                swal.close();
                console.error('Erreur lors du traitement:', error);

                let errorMessage = 'Une erreur est survenue lors du traitement.';
                if (error.message) {
                    errorMessage += '\n\n' + error.message;
                }

                swal('Erreur', errorMessage, 'error');
            }
        }
    },

    async mounted(){

        const queryParams = this.$route.query;

        if(queryParams.data){
            const decodedData = atob(queryParams.data);
            try {
                const jsonData = JSON.parse(decodedData);


                await this.initialize(jsonData);

            } catch (e) {
                console.log(e)
                swal("Erreur", "Les données fournies sont invalides.", "error");
            }


        } else {
            //rediriger vers la page d'accueil
            this.$router.push({
                name: 'home'
            });
        }


    }
}
</script>



// WEBPACK FOOTER //
// Gazo.vue?966fa828